import React from 'react';
import { Icon, message, Upload } from 'antd';
import localDb from '@util/localDb';
import { common } from '@api/req';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJPG = file.type === 'image/jpeg';
  if (!isJPG) {
    message.error('You can only upload JPG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJPG && isLt2M;
}

class Avatar extends React.Component {
  state = {
    loading: false,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      imageUrl: nextProps.value,
    });
  }

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.

      this.props.onChange(info.file.response.data[0].url);
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };

  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
      </div>
    );
    const { imageUrl } = this.state;
    return (
      <Upload
        name="files"
        showUploadList={false}
        listType="picture-card"
        className="avatar-uploader"
        action={`${common.UPLOAD}`}
        headers={{
          Authorization: `${localDb.get('token')}`,
        }}
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
      >
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" style={{ width: '102px', height: '102px' }} />
        ) : (
          uploadButton
        )}
      </Upload>
    );
  }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/comm/upload/UploadSinglePic.js